/* eslint-disable react/no-did-mount-set-state */
import React, { Component } from 'react'
import za from 'za-helper'
import { ZAEnv, ZARef } from 'za-react'
import ImageArea from '~/components/ImageArea'
import TextToggle from '~/components/TextToggle'
import { formatNumber } from '~/utils'

import styles from './TalkItem.css'

export default class TalkItem extends Component {
  componentDidMount() {
    const { data } = this.props
    za.setModule(
      this,
      {
        module: 'Content',
      },
      {
        card: {
          content: {
            id: String(data.id),
          },
        },
      }
    )
  }
  zaRef = React.createRef()
  render() {
    const {
      data: { url, title, content, picUrl, thumsNum, commentNum },
    } = this.props
    return (
      <ZAEnv block="activityAnswerCard">
        <ZARef ref={this.zaRef} />
        <div
          className={styles.talkItem}
          onClick={() => {
            za.trackEvent(this, { id: 2049 })
            // eslint-disable-next-line no-unused-expressions
            this.zaRef.current.trackEvent({
              eventType: 'Click',
              action: 'OpenUrl',
              elementLocation: { type: 'Card' },
            })
            this.props.onClick(url)
          }}
        >
          <div>
            <TextToggle
              className={styles.talkTitle}
              content={title}
              minLength={65}
            />
            <div className={styles.talkContentWrap}>
              <TextToggle
                className={styles.talkContent}
                content={content}
                minLength={90}
              />
              <ImageArea className={styles.talkImage} src={picUrl} />
            </div>
          </div>
          {thumsNum >= 0 && (
            <div className={styles.talkData}>
              {formatNumber(thumsNum)} 赞同 · {formatNumber(commentNum)} 评论
            </div>
          )}
        </div>
      </ZAEnv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Talk/TalkItem.js